<div class="songs-container" style="width: 100%; display: flex; flex-direction: column;">
  <img src="assets/images/RevelBase_Songs.png" alt="RevelBase Songs" class="choir-resources-image">
  
  <!-- Desktop toolbar: search/filters on the left, Add button on the right -->
  <div *ngIf="!(isHandset$ | async)" style="display: flex; align-items: center; gap: 20px; margin-bottom: 10px;">
    <div class="search-song" style="flex: 1; display: flex; align-items: center; gap: 10px;">
      <label for="song-search" style="white-space: nowrap;">Search Song:</label>
      <input
        id="song-search"
        type="text"
        [(ngModel)]="searchQuery"
        (input)="searchSongs()"
        placeholder="Search by name or description"
        class="narrow-search"
        style="width: 500px;"
      />
      <label for="composer-select" style="white-space: nowrap;">Composer:</label>
      <mat-form-field class="dense-field" appearance="outline" subscriptSizing="dynamic" style="width: 200px; margin: 0;">
        <mat-select id="composer-select" [(ngModel)]="selectedComposerId" (selectionChange)="filterByComposer()">
          <mat-option value="ALL">(All Composers)</mat-option>
          <mat-option *ngFor="let composer of composers" [value]="composer.id">
            {{ composer.surname || composer.fullName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <button *ngIf="currentUserIsAdmin" mat-raised-button color="primary" (click)="onAddSong()">Add Song</button>
  </div>

  <!-- Handset toolbar: match composers handset design -->
  <div *ngIf="isHandset$ | async" class="toolbar-row" style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px; margin-bottom: 10px;">
  <div class="search-song" style="display: flex; align-items: center; gap: 8px;">
      <label for="song-search-handset" style="white-space: nowrap;">Search Song:</label>
      <input
        id="song-search-handset"
        type="text"
        [(ngModel)]="searchQuery"
        (input)="searchSongs()"
    class="handset-search"
    style="flex: 1 1 auto; max-width: 320px;"
      />
    </div>
    <div class="composer-filter" style="display: flex; align-items: center; gap: 8px;">
      <label for="composer-select-handset" style="white-space: nowrap;">Composer:</label>
      <mat-form-field class="dense-field" appearance="outline" subscriptSizing="dynamic" style="flex: 1 1 auto; max-width: 320px; margin: 0;">
        <mat-select id="composer-select-handset" [(ngModel)]="selectedComposerId" (selectionChange)="filterByComposer()">
          <mat-option value="ALL">(All Composers)</mat-option>
          <mat-option *ngFor="let composer of composers" [value]="composer.id">
            {{ composer.surname || composer.fullName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- List of Songs -->
  <div class="table-scroll">
    <table mat-table [dataSource]="filteredSongs" class="mat-elevation-z8" style="width: 100%;">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Song Name</th>
        <td mat-cell *matCellDef="let song">
          <a href="#" (click)="viewSong(song); $event.preventDefault()">{{ song.name }}</a>
        </td>
      </ng-container>

      <!-- Composer Column -->
      <ng-container matColumnDef="composer">
        <th mat-header-cell *matHeaderCellDef>Composer Name</th>
        <td mat-cell *matCellDef="let song">{{ getComposerName(song.composerId) }}</td>
      </ng-container>

      <!-- Desktop-only column definitions (safe even if not in displayedColumns) -->
      <!-- Language Column -->
      <ng-container matColumnDef="language">
        <th mat-header-cell *matHeaderCellDef>Language</th>
        <td mat-cell *matCellDef="let song">{{ song.language }}</td>
      </ng-container>

      <!-- Year Column -->
      <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef>Year</th>
        <td mat-cell *matCellDef="let song">{{ song.year }}</td>
      </ng-container>

      <!-- Genre Column -->
      <ng-container matColumnDef="genre">
        <th mat-header-cell *matHeaderCellDef>Genre</th>
        <td mat-cell *matCellDef="let song">{{ song.genre }}</td>
      </ng-container>

      <!-- Genre Group Column -->
      <ng-container matColumnDef="genreGroup">
        <th mat-header-cell *matHeaderCellDef>Genre Group</th>
        <td mat-cell *matCellDef="let song">{{ song.genreGroup }}</td>
      </ng-container>

      <!-- Voicing Column -->
      <ng-container matColumnDef="voicing">
        <th mat-header-cell *matHeaderCellDef>Voicing</th>
        <td mat-cell *matCellDef="let song">{{ song.voicing }}</td>
      </ng-container>

      <!-- Instruments Column -->
      <ng-container matColumnDef="instruments">
        <th mat-header-cell *matHeaderCellDef>Instruments</th>
        <td mat-cell *matCellDef="let song">{{ song.instruments }}</td>
      </ng-container>

      <!-- Actions Column (admin only in displayedColumns) -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef><span *ngIf="currentUserIsAdmin">Actions</span></th>
        <td mat-cell *matCellDef="let song">
          <ng-container *ngIf="currentUserIsAdmin">
            <button mat-button color="primary" (click)="editSong(song)">Edit</button>
            <button mat-button color="warn" (click)="deleteSong(song.id)">Delete</button>
          </ng-container>
        </td>
      </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>